import React from 'react';

//Components
import Input from '../form/new/Input';

//Constants
import { INPUT_TYPES } from '../form/constants/fieldTypes';

interface IAccessCodeProps {
    labelText: string;
    labelClasses: string[];
    wrapperClasses: string[];
    inputClasses: string[];
    value: string;
    isInputRequired: boolean;
    maxLength: number;
    isErrorVisible?: boolean;
    messageText: React.ReactNode;
    textReplacements?: any;
    errorWrapperClasses: string[];
    errorClasses: string[];
    validationType?: string;
    isRequired: boolean;
    disabled?: boolean;
    onChange: (e: { target: { value: string; name: string } }) => void;
    onBlur: (e: { target: { value: string; name: string } }) => void;
    onFocus: (e: { target: { value: string; name: string } }) => void;
}

const AccessCode = (props: IAccessCodeProps) => {
    return (
        <Input
            label={{
                labelText: props.labelText,
                isRequired: props.isRequired,
                labelClasses: props.labelClasses,
                wrapperClasses: props.wrapperClasses,
            }}
            input={{
                id: 'accessCode',
                name: 'accessCode',
                inputClasses: props.inputClasses,
                type: INPUT_TYPES.TEXT,
                value: props.value,
                disabled: props.disabled,
                isInputRequired: props.isInputRequired,
                maxLength: props.maxLength,
                //onChange: props.onChange,
                validationType: props.validationType,
                onFocus: props.onFocus,
            }}
            errors={{
                isErrorVisible: props.isErrorVisible,
                messageText: props.messageText,
                textReplacements: props.textReplacements,
                errorWrapperClasses: props.errorWrapperClasses,
                errorClasses: props.errorClasses,
            }}
            actions={{
                handleFieldChange: (value: string) => props.onChange({ target: { value: value.replace(/\s/g, ''), name: 'accessCode' } }),
                handleFieldBlur: (value: string) => props.onBlur({ target: { value, name: 'accessCode' } }),
                handleFieldFocus: (value: string) => props.onFocus({ target: { value, name: 'accessCode' } }),
            }}
        />
    );
};

export default AccessCode;
